import { Tabs } from '@components/utility/tabs';
import { APP_PREFIX_PATH } from '@constants/common';
import { usePrefixedNavigate } from '@hooks/usePrefixedNavigate';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Outlet, useLocation } from 'react-router-dom';

const TABS = [
    { label: <FormattedMessage id="account.details.overview" defaultMessage="Overview" />, path: '/accounts/details' },
    {
        label: <FormattedMessage id="account.details.edit" defaultMessage="Account Details" />,
        path: '/accounts/details/edit',
    },
    {
        label: <FormattedMessage id="account.details.events" defaultMessage="Events" />,
        path: '/accounts/details/my-events',
    },
    {
        label: <FormattedMessage id="account.details.security" defaultMessage="Security" />,
        path: '/accounts/details/security',
    },
    {
        label: <FormattedMessage id="account.details.connections" defaultMessage="Connections" />,
        path: '/accounts/details/connections',
    },
    {
        label: <FormattedMessage id="account.details.settings" defaultMessage="Settings" />,
        path: '/accounts/details/settings',
    },
];

const AccountLayout = () => {
    const navigate = usePrefixedNavigate();
    const { pathname } = useLocation();

    const relativePath = pathname.replace(APP_PREFIX_PATH, '');
    const activeTab = TABS.findIndex((tab) => tab.path === relativePath);

    return (
        <Box px={{ xs: '10px', md: '62px' }} py="24px">
            <Tabs
                value={activeTab === -1 ? 0 : activeTab}
                onChange={(_, newValue: number) => navigate(TABS[newValue].path)}
            >
                {TABS.map((tab) => (
                    <Tabs.Tab key={tab.path} label={tab.label} />
                ))}
            </Tabs>
            <Box mt="24px">
                <Outlet />
            </Box>
        </Box>
    );
};

export { AccountLayout };
